import React, { useState } from "react";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import Input from "../../../components/FormComponents/Input";

const MasterDataTemplateEditor = ({ file, templateData, setTemplateData }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { isDirty, markClean } = useDirtyChecker(templateData);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setTemplateData((prev) => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const { message } = await axiosInstance.patch(`/masterdata/${file.id}`, {
        ...templateData,
        name: file.name
      });
      toastSuccess(message || "Master data template saved successfully.");
      markClean();
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="d_flex flex_column">
      <GenericActionBar
        path={
          <div>
            <em>Master Data Templates</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSave
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />

      <div className="template_form_outer">
        <div className="builder_form w_50 m_auto border_full p_4">
          <div className="d_flex align_center mb_3">
            <label style={{ color: "#667085" }}>Type</label>
            <span style={{ marginLeft: "14px", marginRight: "8px" }}>:</span>
            <span className="builder_label">{templateData.type}</span>
          </div>

          <div className="d_flex align_center mb_3">
            <label style={{ color: "#667085" }}>Offline</label>
            <span style={{ marginLeft: "4px", marginRight: "8px" }}>:</span>
            <Input type="checkbox" name="is_offline" checked={templateData.is_offline} onChange={handleChange} />
          </div>

          <div className="d_flex align_center">
            <label style={{ color: "#667085" }}>Name</label>
            <span style={{ marginLeft: "7px", marginRight: "8px" }}>:</span>
            <span className="builder_label">{templateData.name}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterDataTemplateEditor;
